module.exports = __webpack_public_path__ + "static/media/emirates-card-light.e67db69c.svg";